import React, { useContext } from "react"
import { observer } from "mobx-react"
import { Anchor, Text, Title } from "@mantine/core"
import { IconArrowRight } from "@tabler/icons-react"
import { AppWorkspaceContext } from "../../stores/AppWorkspace"
import { LANDING_COPY } from "../../../docs/catalog"
import { LEARN_PATH } from "../../helpers/constants"

// The homepage's LEARN section: one card per English /learn article the front
// matter does not keep off the homepage, from the server's bootstrap (LearnPage.cards), in the frameworks' card style. The
// articles are server-rendered pages, so every link is a plain one.
export const LearnGrid: React.FC = observer(() => {
  const workspace = useContext(AppWorkspaceContext)
  const copy = LANDING_COPY.learn
  const pages = workspace.learnPages.filter((page) => page.home)
  if (pages.length === 0) return null

  return (
    <section id="learn" className="or-frameworks or-platforms" aria-labelledby="or-learn-title">
      <Text className="or-eyebrow">{copy.eyebrow}</Text>
      <Title order={2} id="or-learn-title" className="or-frameworks-title">
        {copy.headline}
      </Title>
      <Text className="or-frameworks-lede">{copy.subline}</Text>

      <ul className="or-framework-cards">
        {pages.map((page) => (
          <li key={page.path} className="or-framework-card or-platform-card">
            <a className="or-framework-card-link" href={page.path}>
              <Text className="or-framework-card-requires">{page.eyebrow}</Text>
              <Text className="or-framework-card-title">{page.title}</Text>
              <Text className="or-framework-card-pitch">{page.description}</Text>
              <Text className="or-framework-card-requires">
                {copy.read} <IconArrowRight size={14} aria-hidden="true" />
              </Text>
            </a>
          </li>
        ))}
      </ul>

      <Anchor className="or-platforms-all" href={LEARN_PATH}>
        {copy.all} <IconArrowRight size={14} aria-hidden="true" />
      </Anchor>
    </section>
  )
})
